import { render, staticRenderFns } from "./DGListaInterventi.vue?vue&type=template&id=97038f96&"
import script from "./DGListaInterventi.vue?vue&type=script&lang=js&"
export * from "./DGListaInterventi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports